up.compiler('[change-cookie-consent-settings]', (elem) => {
  up.on(elem, 'click', (evt) => {
    up.emit('app:cookieConsentDialog:show')
    evt.preventDefault()
  })
})
